module.exports = __webpack_public_path__ + "static/media/3_Plans.9b53bc93.png";